import config from '../config';
import selectedEnvironment from '../env';

const API_URL = `${config[selectedEnvironment].API_URL}`;

const authHeaders = (token) => ({
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json',
});

const GetByCaseId = async (caseId, token) => {
    return fetch(`${API_URL}/JournalEntryTemplates/${caseId}`, {
        method: 'GET',
        headers: authHeaders(token),
    });
};

const GetById = async (id, token) => {
    return fetch(`${API_URL}/JournalEntryTemplates/byId/${id}`, {
        method: 'GET',
        headers: authHeaders(token),
    });
};

const Create = async (dto, token) => {
    return fetch(`${API_URL}/JournalEntryTemplates/Create`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(dto),
    });
};

const Update = async (dto, token) => {
    return fetch(`${API_URL}/JournalEntryTemplates/Update`, {
        method: 'PUT',
        headers: authHeaders(token),
        body: JSON.stringify(dto),
    });
};

const Delete = async (id, token) => {
    return fetch(`${API_URL}/JournalEntryTemplates/${id}`, {
        method: 'DELETE',
        headers: authHeaders(token),
    });
};

const Apply = async (dto, token) => {
    return fetch(`${API_URL}/JournalEntryTemplates/Apply`, {
        method: 'POST',
        headers: authHeaders(token),
        body: JSON.stringify(dto),
    });
};

const JournalEntryTemplateService = {
    GetByCaseId,
    GetById,
    Create,
    Update,
    Delete,
    Apply,
};

export default JournalEntryTemplateService;
